import { Tween } from '../../../vendor_core/core/src/Tween';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import { State } from '../../../vendor_core/core/src/states/State';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import Utils from '../../../vendor_core/core/src/utils/Utils';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import ReelGroup from '../../../vendor_core/core/src/views/ReelGroup';
import CoinModel from '../../model/CoinModel';
import ICoin from '../../model/ICoin';


export default class TRWCoinRainState extends State {
    protected rainAnimDuration = 1700;
    protected startRainAnimDelay = 1800;
    protected rainAnimDelay = 200; // 200
    protected transformAnimDelay = 100; // 100
    protected chestAnticipationTime = 1000; // 100
    public enter(): void {
        super.enter();
        const stateIndex = CoinModel.currentChestState;
        // Here must play first chest anim !!
        // if (CoinModel.activeCoins < 5) {

            Tween.delayedCall(((this.rainAnimDelay + this.chestAnticipationTime) / 1000), () => SoundController.playSound("coinRain", false))
            Tween.delayedCall(0.5, () => this.init(stateIndex))
            Tween.delayedCall(3, () => SoundController.playSound("coinRainEnd", false));
        // } else {
        //     // CoinModel.playCoinRainChestAnim();
        //     Tween.delayedCall(((this.rainAnimDelay + this.chestAnticipationTime) / 1000), () => SoundController.playSound("coinRain", false))
        //     Tween.delayedCall((this.startRainAnimDelay / 1000), () => this.init(stateIndex))
        // }
        CoinModel.isCoinRainPlayed = true;
        // this.init();
    }

    init(chestStateIndex: number): void {
        const rainData = this.getRainData();
        const reelFront = ViewManager.getLayer(DefaultLayers.ReelsFront).getCurrentScene();
        const reelBack = ViewManager.getLayer(DefaultLayers.ReelsBack).getCurrentScene();

        const rainAnim = reelFront.spineAnimations.get("coinRain");
        const chestCoinAnim = reelBack.spineAnimations.get("chestCoins");
        const chestScene = ViewManager.getLayer("ChestBar")?.getCurrentScene();
        const chestAnim = chestScene.spineAnimations.get("chest");

        chestAnim.play(`st_${chestStateIndex}_coin_rain`);

        Tween.delayedCall((this.chestAnticipationTime / 1000), () => {
            chestCoinAnim.play(`c_st_${chestStateIndex}_coin_rain`);

            rainAnim.playAsync(`rain_${CoinModel.coinRainIndex}`);
            rainData.forEach((d, index) => {
                let delay = this.rainAnimDelay * index;
                const sym = ReelGroup.instance.getSymbolAt(d.coordinate.x, d.coordinate.y);
                const transformDelay = delay + this.transformAnimDelay;
                Tween.delayedCall((transformDelay / 1000), () => {
                    CoinModel.playCoinTransformAnim(sym, d, "coin_rain_transform");
                    CoinModel.updateCoinsState(1);
                    SoundController.playSound("coinRainSymbolToCoin");
                })
            })
        })

        this.setExitState(this.getExitDelay(rainData.length))
    }

    getExitDelay(coinsNumber: number): number {
        const delayInMs = (coinsNumber * (this.rainAnimDelay + this.transformAnimDelay)) + this.rainAnimDuration + this.chestAnticipationTime;
        return delayInMs / 1000
    }

    setExitState(delay: number): void {
        Tween.delayedCall(delay, () => {
            this.exit()
        })

    }
    getRainData = (): ICoin[] => {
        const data: ICoin[] = Utils.deepClone(SpinModel.generations[SpinModel.cascadeIndex].rainCoins);
        return data.sort((a, b) => a.coordinate.x - b.coordinate.x)
    };
}
